<template>
  <div>
    <CCard>
      <CCardBody>
        <div class="row justify-content-between">
          <div class="col-10">
            <div class="row mb-3">
              <button
                class="btn btn-sm btn-primary ml-2"
                @click="addModal()"
              >
                <CIcon name="cilMedicalCross" />
                Tambah
              </button>

              <button
                class="btn btn-sm btn-primary ml-2"
                @click="addModalImport()"
              >
                <CIcon name="cilArrowThickToBottom" />
                Import
              </button>
             
              <label class="m-1 ml-3" for="">Select All : </label>
              <input
                type="checkbox"
                v-model="isSelectedAll"
                @change="checkAll()"
              />

              <select v-if="selectedItems.length > 0"
                  style="max-width: 200px"
                  class="form-control form-control-sm mx-2"
                  placeholder="Ketik disini"
                  v-model="selectedAction"
                  @change="changeActionSelected()"
                >
                <option value="0">Action Selected</option>
                <!-- <option value="1">Delete Items Selected</option> -->
                <option value="2">Export Excel Items Selected</option>
                <option value="3">Export Pdf Items Selected</option>
              </select>

              <!-- <button v-if="selectedItems.length > 0"
                class="btn btn-sm btn-primary ml-2"
                @click="addModalAssignToBatch()"
              >
                <CIcon name="cilMedicalCross" />
                Tambahkan Ke Batch
              </button> -->
            </div>
          </div>
        </div>
        <div class="row justify-content-between">
          <div class="col-10">
            <div class="row mb-3">
              <label class="m-1 ml-3" for="">Search : </label>
              <input
                type="text"
                v-model="params.keyword"
                style="max-width: 200px"
                class="form-control form-control-sm mx-2"
                placeholder="Ketik disini"
              />
              <button @click="search()" class="btn btn-sm btn-success">
                Cari
              </button>

              <select
                style="max-width: 200px"
                class="form-control form-control-sm mx-2"
                placeholder="Ketik disini"
                v-model="params.category_id"
                @change="getData()"
              >
                <option value="">Semua Kategori</option>
                <option
                  v-for="category in categories"
                  :value="category.id"
                  :key="category.id"
                >
                  {{ category.name }}
                </option>
              </select>

              <select
                style="max-width: 200px"
                class="form-control form-control-sm mx-2"
                placeholder="Ketik disini"
                v-model="params.event_id"
                @change="getDataCategory()"
              >
                <!-- <option value="">Semua Event</option> -->
                <option
                  v-for="event in events"
                  :value="event.id"
                  :key="event.id"
                >
                  {{ event.event_name }}
                </option>
              </select>

            </div>
          </div>
          <div class="col-2">
            <div class="row">
              <div class="col-12">
                <div class="input-group input-group-sm mb-3">
                  <div class="input-group-prepend">
                    <label class="input-group-text" for="inputGroupSelect01"
                      >Per Halaman</label
                    >
                  </div>
                  <select
                    class="custom-select"
                    style="max-width: 100px"
                    id="inputGroupSelect01"
                    v-model="params.row"
                    @change="getData()"
                  >
                    <!-- <option selected>Pilih...</option> -->
                    <option value="100">100</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                    <option value="2000">2000</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="isSearching">
          <div class="col">
            <h3>
              <span class="badge bg-primary text-light text-bor my-auto">
                {{searchOn}}&nbsp;&nbsp;
                <span @click="searchOff" class="badge bg-light text-dark text-center" style="cursor: pointer">X</span>
              </span>
            </h3>
          </div>
        </div>
        <CDataTable
          class="table-striped"
          :items="computedItems"
          :fields="fields"
          sorter
        >
        <template #select="{ item }">
          <td class="py-2">
            <input 
                type="checkbox"
                @change="check(item)"
                v-model="item.select"
              />
          </td>
        </template>

          <template #birth_certificate="{ item }">
            <td class="py-2">
              <CButton
                @click="showBirthCertificate(item)"
                class="mr-2"
                color="primary"
                square
                size="sm"
              >
                Akte
              </CButton>
              <CButton
                @click="showBuktiBayar(item)"
                class="mr-2"
                color="primary"
                square
                size="sm"
              >
                Bukti
              </CButton>
              <CButton
                @click="showFoto(item)"
                class="mr-2"
                color="primary"
                square
                size="sm"
              >
                Foto
              </CButton>
            </td>
          </template>
          <template #available_slot="{ item }">
            <td class="py-2">
              {{  item.available_slot ? 'Tersedia' : 'Close'  }}
            </td>
          </template>
          <template #action="{ item }">
            <td class="py-2">
              <!-- <CButton
                @click="edit(item)"
                class="mr-2"
                color="warning"
                square
                size="sm"
              >
                Edit
              </CButton>
              <CButton @click="hapus(item)" color="danger" square size="sm">
                Delete
              </CButton> -->
            </td>
          </template>
        </CDataTable>
        <pagination
          v-if="total !== items.length"
          v-model="page"
          :records="total"
          :per-page="100"
          @paginate="pagination"
        />
      </CCardBody>
    </CCard>
    <CModal
      size="lg"
      :title="
        isUpdate ? 'Edit Registran' : 'Tambah Registran'
      "
      centered
      :color="isUpdate ? 'success' : 'primary'"
      :show.sync="createModal"
    >
      <div class="row">
        <div class="col-12">
        
          <CInput
            v-model="form.fullname"
            label="Nama Lengkap"
            placeholder="ketik disini"
          />
          <CInput
            v-model="form.nickname"
            label="Nama Panggilan"
            placeholder="ketik disini"
          />
          <CInput
            v-model="form.comunity"
            label="Nama Komunitas"
            placeholder="ketik disini"
          />
          <CInput
            v-model="form.team"
            label="Nama Team"
            placeholder="ketik disini"
          />
          <CInput
            v-model="form.plat_number"
            label="Plat Number"
            placeholder="ketik disini"
          />
          <CInput
            type="date"
            v-model="form.birth_of_date"
            label="Tanggal Lahir"
            placeholder="ketik disini"
          />
          <CInput
            v-model="form.phone_number"
            label="No. HP"
            placeholder="ketik disini"
          />
          <CInput
            v-model="form.email"
            label="Email"
            placeholder="ketik disini"
          />

           <CInput
            v-model="form.clothes_size"
            label="Ukuran Baju"
            placeholder="ketik disini"
          />

          <label for="">Kategori</label>
          <select
            name=""
            v-model="form.category_id"
            class="form-control"
            placeholder="Pilih"
          >
            <option v-for="category in categories" :key="category" :value="category.id">{{ category.name }}</option>
          </select>

          <label>Event</label>
          <select
            name=""
            v-model="form.event_id"
            class="form-control"
            placeholder="Pilih"
          >
            <option v-for="event in events" :key="event" :value="event.id">{{ event.event_name }}</option>
          </select>
     
          <div class="row">
            <div class="col">
              <label for="document_supports">Upload Akte</label>
              <div
                  class="card border d-flex justify-content-center text-center"
                  style="height: 150px"
              >
                  <div class="align-self-center mb-3">
                      <img src="@/assets/upload.png" width="100px" />
                  </div>
                  <button
                      class="btn btn-sm btn-primary align-self-center"
                      style="width: 15%"
                      @click="upload"
                      >
                      Upload Disini
                  </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="div">
                  <input
                      hidden
                      type="file"
                      class="form-control"
                      ref="upload"
                      @change="selectFile"
                  />
              </div>
            </div>
          </div>
          <div class="row">
              <div class="col-md-12" v-if="form.birth_certificate">
              <CCardLink :href="form.birth_certificate" target="_blank" class="">
                  <img :src="form.birth_certificate" width="100%" />
              </CCardLink>
              <button
                  class="btn btn-danger btn-sm btn-block mt-2"
                  @click="deleteFile(index)"
              >
                  Hapus
              </button>
              <br />
              </div>
          </div>

          <!-- bukti bayar -->
          <div class="row">
            <div class="col">
              <label for="document_supports">Upload Bukti Bayar</label>
              <div
                  class="card border d-flex justify-content-center text-center"
                  style="height: 150px"
              >
                  <div class="align-self-center mb-3">
                      <img src="@/assets/upload.png" width="100px" />
                  </div>
                  <button
                      class="btn btn-sm btn-primary align-self-center"
                      style="width: 15%"
                      @click="uploadBukti"
                      >
                      Upload Disini
                  </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="div">
                  <input
                      hidden
                      type="file"
                      class="form-control"
                      ref="upload_bukti"
                      @change="selectFileBukti"
                  />
              </div>
            </div>
          </div>
          <div class="row">
              <div class="col-md-12" v-if="form.proof_of_payment">
              <CCardLink :href="form.proof_of_payment" target="_blank" class="">
                  <img :src="form.proof_of_payment" width="100%" />
              </CCardLink>
              <button
                  class="btn btn-danger btn-sm btn-block mt-2"
                  @click="deleteFile(index)"
              >
                  Hapus
              </button>
              <br />
              </div>
          </div>
          <!-- bukti bayar -->

          <!-- foto -->
          <div class="row">
            <div class="col">
              <label for="document_supports">Upload Foto</label>
              <div
                  class="card border d-flex justify-content-center text-center"
                  style="height: 150px"
              >
                  <div class="align-self-center mb-3">
                      <img src="@/assets/upload.png" width="100px" />
                  </div>
                  <button
                      class="btn btn-sm btn-primary align-self-center"
                      style="width: 15%"
                      @click="uploadFoto"
                      >
                      Upload Disini
                  </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="div">
                  <input
                      hidden
                      type="file"
                      class="form-control"
                      ref="upload_foto"
                      @change="selectFileFoto"
                  />
              </div>
            </div>
          </div>
          <div class="row">
              <div class="col-md-12" v-if="form.photo">
              <CCardLink :href="form.photo" target="_blank" class="">
                  <img :src="form.photo" width="100%" />
              </CCardLink>
              <button
                  class="btn btn-danger btn-sm btn-block mt-2"
                  @click="deleteFile(index)"
              >
                  Hapus
              </button>
              <br />
              </div>
          </div>
          <!-- foto -->

        </div>
      </div>
      <template slot="footer">
        <div>
          <button @click="cancel" class="btn btn-secondary mr-3">Batal</button>

          <button @click="submit" v-if="!isUpdate" class="btn btn-primary">
            Tambah Registran
          </button>
          <button @click="update" v-if="isUpdate" class="btn btn-primary">
            Update Registran
          </button>
        </div>
      </template>
    </CModal>
    <CModal
      size="lg"
      title="Import Data"
      centered
      color="primary"
      :show.sync="createModalImport"
    >
        <a href="Registran.xlsx" download class="btn btn-primary">Download format</a>
        <br /><br />
        <input
            type="file"
            class="form-control"
            ref="uploadFieldBefore"
            @change="selectFileImport"
          />
        <template slot="footer">
        <div>
          <button @click="cancelImport" class="btn btn-secondary mr-3">Batal</button>

          <button @click="importData" class="btn btn-primary">
            Proses Import
          </button>
        </div>
      </template>
    </CModal>

    <!-- modal akte kelahiran -->
    <CModal
      size="lg"
      title="Akte Kelahiran"
      centered
      color="primary"
      :show.sync="createAkte"
    >
        <img :src="birth_certificate_image" class="img" style="width: 100%;" />
    </CModal>

     <CModal
      size="lg"
      title="Foto"
      centered
      color="primary"
      :show.sync="createFoto"
    >
        <img :src="foto" class="img" style="width: 100%;" />
    </CModal>

    <!-- modal bukti bayar -->
    <CModal
      size="lg"
      title="Bukti Bayar"
      centered
      color="primary"
      :show.sync="createBuktiBayar"
    >
        <img :src="proof_of_payment_image" class="img" style="width: 100%;" />
        <template slot="footer">
        <div>
          <button @click="approvePembayaran()" class="btn btn-primary">
            Approve Pembayaran
          </button>
        </div>
      </template>
    </CModal>

    <CModal
      size="lg"
      title="Tambahkan ke Batch"
      centered
      color="primary"
      :show.sync="createModalAssignToBatch"
    >
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Nama</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in selectedItems" :key="item">
              <td>{{ getBySelected(item).fullname }}</td>
            </tr>
          </tbody>
        </table>
        
        <template slot="footer">
        <div>
          <button @click="assignToBatch()" class="btn btn-primary">
            Assign to Batch
          </button>
        </div>
      </template>
    </CModal>
  </div>
</template>

<script>
import * as data from "../../model/registran";
import { uploadImage } from "@/utils/fileUpload";
import FileSaver from "file-saver";

export default {
  data() {
    return {
      file: null,
      createModal: false,
      createBuktiBayar: false,
      createAkte: false,
      createFoto: false,
      createModalImport: false,
      createModalAssignToBatch: false,
      fields: [],
      isUpdate: false,
      items: [],
      events: [],
      categories: [],
      kecamatans: [],
      imageListAfter: [],
      imageListProcess: [],
      imageListBefore: [],
      selectedItems: [],
      selectedByName: [],
      isSelectedAll: false,
      selectedAction: 0,
      page: 1,
      total: 0,
      to: 0,
      form: {
        available_slot: 1,
        proof_of_payment: '',
        birth_certificate: '',
        foto: ''
      },
      user: JSON.parse(localStorage.getItem("user")),
      params: {
        sorttype: "desc",
        sortby: "id",
        row: 100,
        page: 1,
        keyword: "",
        category_id: "",
        event_id: ""
      },
      isSearching: false,
      searchOn: '',
      birth_certificate_image: '',
      foto: '',
      proof_of_payment_image: ''
    };
  },
  methods: {
    getBatchByCategory() {
      this.$store
        .dispatch("registran/getKecamatan", this.params)
        .then((resp) => {
          this.kecamatans = resp.data;
          console.log(this.kecamatans, "kecamatan");
        })
        .catch((e) => {
          this.$toast.error("gagal mengambil data  \n", e);
        });
    },
    getBySelected(registranId) {
      return this.items.find(item => item.id === registranId);
    },
    assignToBatch() {

    },
    addModalAssignToBatch() {
      this.createModalAssignToBatch = true;
    },
    getDataCategory() {
      var loading = this.$loading.show();
      let params = {
        sorttype: "desc",
        sortby: "id",
        row: 1000,
        page: 1,
        type: [0, 1],
        keyword: "",
        event_id: this.params.event_id
      }
      this.$store
        .dispatch("category/getCategoryList", params)
        .then((resp) => {
          this.params.category_id = "";
          this.categories = resp.data.data;
          this.getData();
          loading.hide();
        })
        .catch((e) => {
          this.$toast.error("gagal mengambil data  \n", e);
          loading.hide();
        });
    },
    approvePembayaran() {
      var loading = this.$loading.show();
      this.$store
        .dispatch("registran/approve", this.form.uuid)
        .then(() => {
          this.$toast.success("Berhasil menambahkan di approve");
          loading.hide();
          this.createBuktiBayar = false;
          this.getData();
        })
        .catch((e) => {
          console.log(e)
          loading.hide();
        });
    },
    showBirthCertificate(item) {
      this.birth_certificate_image = item.birth_certificate;
      this.createAkte = true;
      this.form = item;
    },
    showBuktiBayar(item) {
      this.proof_of_payment_image = item.proof_of_payment;
      this.createBuktiBayar = true;
      this.form = item;
    },
    showFoto(item) {
      this.foto = item.photo;
      this.createFoto = true;
      this.form = item;
    },
    search() {
      if (this.params.keyword != "") {
        this.isSearching = true;
        this.getData();
        this.searchOn = this.params.keyword;
      } else {
        this.$toast.error("Inputan tidak boleh kosong !!");
      }
    },

    searchOff(){
      this.isSearching = false;
      this.params.keyword = '';
      this.getData();
    },
    submit() {
      var loading = this.$loading.show();
      // this.form.event_id = this.form.event_id.value;
      this.$store
        .dispatch("registran/addRegistran", this.form)
        .then(() => {
          this.$toast.success("Berhasil menambahkan data");
          loading.hide();
          this.createModal = false;
          this.form = {
          };
          this.getData();
        })
        .catch(() => {
          loading.hide();
        });
    },
    edit(item) {
      this.form = item;

      // this.form.event_id = {
      //   value: item.event.id,
      //   label: item.event.name
      // }

      this.form.event_id = item.event.id;
      
      this.isUpdate = true;
      this.createModal = true;
    },
    cancel() {
      this.form = {
        type: 0,
      };
      this.createModal = false;
    },
    update() {
      var loading = this.$loading.show();
      // this.form.event_id = this.form.event_id.value;
      this.form.clothes_size = 'M';
      this.$store
        .dispatch("registran/updateRegistran", {
          id: this.form.uuid,
          data: this.form,
        })
        .then(() => {
          this.$toast.success("Berhasil merubah data ");
          loading.hide();
          this.createModal = false;
          this.form = {
            type: 0,
          };
          this.getData();
        })
        .catch(() => {
          loading.hide();
        });
    },
    hapus(item) {
      if (confirm("Data akan dihapus !!")) {
        this.$store
          .dispatch("registran/deleteRegistran", item.uuid)
          .then(() => {
            this.$toast.success("Berhasil menghapus data ");

            this.form = {
              image: '',
            };
            this.getData();
          })
          .catch((e) => {
            this.$toast.error(e);
            loading.hide();
          });
      }
    },
    getData() {
      var loading = this.$loading.show();
      this.$store
        .dispatch("registran/getRegistran", this.params)
        .then((resp) => {

          // this.getDataCategory();

          this.items = resp.data.data;
          this.total = resp.data.total;
          this.to = resp.data.to;

          // khusus untuk checkbox
          this.selectedItems = [];
          this.items.forEach(element => {
            if (this.isSelectedAll) {
              element.select = true;
              this.selectedItems.push(element.id);
            } else {
              element.select = false;
            }
          });
          loading.hide();
        })
        .catch((e) => {
          this.$toast.error("gagal mengambil data  \n", e);
          loading.hide();
        });
    },
    addModal() {
      this.isUpdate = false;
      this.form = {
        available_slot: 1,
        proof_of_payment: '',
        birth_certificate: ''
      }
      this.createModal = true;
    },
    addModalImport() {
      this.createModalImport = true;
    },
    pagination(page) {
      this.page = page;
      this.params.page = page;
      this.getData();
    },
    uploadAfter() {
      this.$refs.uploadFieldAfter.click();
    },
    upload() {
      this.$refs.upload.click();
    },
    uploadBukti() {
      this.$refs.upload_bukti.click();
    },
    uploadFoto() {
      this.$refs.upload_foto.click();
    },
    selectFile(event) {
      this.file = event.target.files[0];
      var loading = this.$loading.show();
      uploadImage(this.file)
        .then((resp) => {
          this.form.birth_certificate = resp;
          loading.hide();
          alert("File berhasil diupload !!");
        })
        .catch((e) => {
          loading.hide();
          alert("Terjadi kesalahan !! | " + e);
        });
    },
    selectFileBukti(event) {
      this.file = event.target.files[0];
      var loading = this.$loading.show();
      uploadImage(this.file)
        .then((resp) => {
          this.form.proof_of_payment = resp;
          loading.hide();
          alert("File berhasil diupload !!");
        })
        .catch((e) => {
          loading.hide();
          alert("Terjadi kesalahan !! | " + e);
        });
    },
    selectFileFoto(event) {
      this.file = event.target.files[0];
      var loading = this.$loading.show();
      uploadImage(this.file)
        .then((resp) => {
          this.form.foto = resp;
          loading.hide();
          alert("File berhasil diupload !!");
        })
        .catch((e) => {
          loading.hide();
          alert("Terjadi kesalahan !! | " + e);
        });
    },

    selectFileAfter(event) {
      this.file = event.target.files[0];
      var loading = this.$loading.show();
      uploadImage(this.file)
        .then((resp) => {
          this.imageListAfter.push(resp);
          loading.hide();
          alert("File berhasil diupload !!");
        })
        .catch((e) => {
          loading.hide();
          alert("Terjadi kesalahan !! | " + e);
        });
    },
    uploadProcess() {
      this.$refs.uploadFieldProcess.click();
    },
    selectFileProcess(event) {
      this.file = event.target.files[0];
      var loading = this.$loading.show();
      uploadImage(this.file)
        .then((resp) => {
          this.imageListProcess.push(resp);
          loading.hide();
          alert("File berhasil diupload !!");
        })
        .catch((e) => {
          loading.hide();
          alert("Terjadi kesalahan !! | " + e);
        });
    },
    uploadBefore() {
      this.$refs.uploadFieldBefore.click();
    },
    selectFileBefore(event) {
      this.file = event.target.files[0];
      var loading = this.$loading.show();
      uploadImage(this.file)
        .then((resp) => {
          this.imageListBefore.push(resp);
          loading.hide();
          alert("File berhasil diupload !!");
        })
        .catch((e) => {
          loading.hide();
          alert("Terjadi kesalahan !! | " + e);
        });
    },
    check(item) {
      if (item.select) {
        this.selectedItems.push(item.id);
      } else {
        const index = this.selectedItems.indexOf(item.id);
        this.selectedItems.splice(index, 1);
      }
    },
    checkAll() {
      this.getData();
    },
    changeActionSelected() {
      switch (Number(this.selectedAction)) {
        case 1:
          console.log('deleted')
          // this.deleteSelected('delete');
          break;
        case 2:
          console.log('export excel')
          this.exportExcel('export_excel');
          break;
        case 3:
          console.log('export pdf')
          this.exportPDF();
          break;
      }
    },
    deleteSelected(action) {
      var loading = this.$loading.show();
      this.$store
        .dispatch("registran/selectedAction", 
        {
          action: action,
          data: this.selectedItems,
        })
        .then(() => {
          this.$toast.success("Item Selected Berhasil diproses");
          loading.hide();
          this.createModal = false;
          this.form = {
          };
          this.getData();
        })
        .catch((e) => {
          this.$toast.error("gagal mengambil data  \n", e);
          loading.hide();
        });
    },
    openModalExcel() {
      this.exportModal = true;
      this.exportType = "Export Excel";
    },
    openModalPDF() {
      this.exportModal = true;
      this.exportType = "Export PDF";
    },
    exportExcel(action) {
      console.log({
          data: this.selectedItems,
        })
      var loading = this.$loading.show();
      this.$store
       .dispatch("registran/exportReport", {
          data: this.selectedItems,
        })
        .then((resp) => {
          loading.hide();
          FileSaver.saveAs(
            resp.data,
            "Registran"
          );
          this.exportModal = false;
          this.exportDataParams = {};
        })
        .catch(() => {
          loading.hide();
        });
    },
    exportPDF() {
      this.$router.push({ name: "RegistranExportPDF", query: { data: this.selectedItems } });
    },
    getKecamatan() {
      this.$store
        .dispatch("registran/getKecamatan", this.params)
        .then((resp) => {
          this.kecamatans = resp.data;
          console.log(this.kecamatans, "kecamatan");
        })
        .catch((e) => {
          this.$toast.error("gagal mengambil data  \n", e);
        });
    },
    selectFileImport(event) {
      this.file = event.target.files[0];
    },
    cancelImport() {
      this.file = null;
    },
    importData() {
      var loading = this.$loading.show();
      this.$store
        .dispatch("registran/importRegistran", this.file)
        .then((res) => {
          this.$toast.success(res.data.message);
          loading.hide();
          this.createModalImport = false;
          this.form = {
          };
          this.getData();
        })
        .catch((e) => {
          console.log(e)
          this.$toast.error(e);
          loading.hide();
        });
    },
    getEvents() {
      var loading = this.$loading.show();
      let params = {
        sorttype: "desc",
        sortby: "id",
        row: 1000,
        page: 1,
        type: [0, 1],
        keyword: "",
      }
      this.$store
          .dispatch("event/getEventList", params)
          .then((resp) => {
          this.events = resp.data.data;
          this.params.event_id = this.events[0].id
          this.getDataCategory();
          loading.hide();
      })
      .catch((e) => {
          this.$toast.error("gagal mengambil data  \n", e);
          loading.hide();
      });
    },
  },
  computed: {
    computedEvent() {
      if (this.form.event_id) {
          let doc = this.events.find(element => {
              return element.id == this.form.event_id
          });
          if (doc) {
              let event = {
                value: doc.value,
                label: doc.label  
              }
            this.form.event_id = event
          }
      }
      return this.events.map((item) => {
        return {
          value: item.id,
          label: item.event_name,
        };
      });
    },
    computedItems() {  
      return this.items.map((item, index) => {
        return {
          index: (this.to - this.items.length) + index+1 + '.',
          ...item,
          clothes_size: item.event ? item.event.clothes_image ? item.clothes_size : '-' : '-',
          event_name: item.event ? item.event.event_name : '-',
          category: item.category ? item.category.name : '-',
          created_at: this.$moment(item.created_at).format("Do MMMM YYYY"),
          updated_at: this.$moment(item.updated_at).format("Do MMMM YYYY"),
        };
      });
    },
  },
  mounted() {
    this.getEvents();
  },

  created() {
    this.fields = data.fields
  },
};
</script>